// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.plan-limit-banner[data-v-edc7494a] {\n\tbackground-color: #000000;\n\tbackground-repeat: no-repeat;\n\tbackground-position: left center;\n\tbackground-size: cover;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
